import React from 'react';
import PropTypes from 'prop-types';
import './style';

const propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  width: PropTypes.string,
  position: PropTypes.string,
  display: PropTypes.string,
  height: PropTypes.string,
  allowFullScreen: PropTypes.bool,
  placeholder: PropTypes.string,
  getRef: PropTypes.func,
};

const defaultProps = {
  position: 'absolute',
  display: 'block,',
  height: '100%',
  width: '100%',
  allowFullScreen: false,
  placeholder: 'Loading, Please DO NOT close this window',
  getRef: () => {},
};

class Iframe extends React.PureComponent {
  render() {
    const config = {
      ref: this.props.getRef,
      frameBorder: '0',
      src: this.props.url,
      target: '_parent',
      style: Object.assign({}, {
        position: this.props.position,
        display: this.props.display,
        height: this.props.height,
        width: this.props.width,
      }),
      allowFullScreen: this.props.allowFullScreen,
      height: this.props.height,
      width: this.props.width,
    };

    return <iframe title={this.props.title} {...config} >{this.props.placeholder}</iframe>;
  }
}

Iframe.propTypes = propTypes;
Iframe.defaultProps = defaultProps;
export default Iframe;
